require('./customerCareController.js');
require('./horoscopePageController.js');
require('./openForestsPresentationController.js');
require('./pageController.js');
require('./singlePageController.js');
require('./treeRegisterController.js');
